{
    "InlineExitMessage": "Are you sure you want to close this window? All modified configurations will be lost when closed.",
    "InlineExitConfirm": "Confirm",
    "InlineExitCancel": "Cancel",
    "NotificationsModalTitle": "Notifications",
    "TabSettingsTitle": "Settings",
    "TabSettingsDoNotDisturb": "Enable",
    "TabSettingsCME": "CME",
    "TabSettingsTelServer": "Telephony Server",
    "TabSettingsPartition": "Partition / Site",
    "TabSettingsDevices": "Devices",
    "TabSettingsChannels": "Channels",
    "TabSettingsPhoneNumber": "Phone Number",
    "TabSettingsHeaderGeneral": "General",
    "TabSettingsHeaderScopeFiltering": "Scope Filtering",
    "TabSettingsNotificationChannels": "Notification Channels",
    "TabSetttingsPartitionValidation": "You can only select up to 5 partitions.",
    "TabPreferencesTitle": "Preferences",
    "TabPreferencesHeadingUserNotifications": "User Notifications",
    "IconAddTooltip": "Add Notifications",
    "IconDisabledTooltip": "Notifications are disabled",
    "IconEnabledTooltip": "Notifications are enabled",
    "IconDisabled": "Disabled",
    "NotificationsFooterHelp": "Help",
    "NotificationsFooterCancel": "Cancel",
    "NotificationsFooterSubmit": "Save",
    "NotificationsFooterValiationWarning": "Please correct errors before finishing",
    "NotificationPrefereencesThreshholdPlaceholder": "Placeholder",
    "NotificationPrefereencesThreshholdRequired": "Threshold is required",
    "NotificationPrefereencesThreshholdInvalid": "Threshold must be a number",
    "NotificationFooterValidationError": "Validation errors",
    "NAME": "NotificationsLanguageModal"
}